
<app-cc-form-dialog #ccAllocationFormDialog [transPartKey]="transPartKey"
                    [loading]="formLoading" [submitted]="formSubmitted"
                    [(dialogFormVisible)]="dialogFormVisible"
                    [formConfig]="formConfig" [dialogFormTitle]="dialogFormTitle"
                    [(formRecord)]="formRecord" (onSubmitEvent)="save()"
                    [loadingProgressValue]="loadingProgressValue"
                    [submitButtonLabel]="'page.'+transPartKey+'.dialog.allocate'|translate"
                    [dialogClass]="'allocation-dialog'"
>
  <app-clearing-selection-summary footer-left [summaryBuyValue]="summaryBuyValue" [summarySellValue]="summarySellValue"
                                  [owner]="owners?.length>1?formRecord?.owner:undefined"
                                  [showLoadingSpinner]="true"></app-clearing-selection-summary>
</app-cc-form-dialog>

<p-toast position="bottom-right" ></p-toast>
